import { useCallback, useMemo } from "react";

import { useAddLeagueNamingKey, useAddTournamentNamingKey } from "@/hooks";
import { MessageKey, useT } from "@/i18n";

import { GlobalSearchItemType } from "./GlobalSearch.types";

export const useGetSearchItemTypeLabel = () => {
  const addLeagueNamingKey = useAddLeagueNamingKey();
  const addTournamentNamingKey = useAddTournamentNamingKey();
  const t = useT();

  const GLOBAL_SEARCH_ITEM_TYPE_LABELS: { [key in GlobalSearchItemType]: MessageKey } = useMemo(
    () => ({
      page: "general.globalSearch.itemTypes.page",
      user: "general.globalSearch.itemTypes.user",
      tournament: addTournamentNamingKey("general.globalSearch.itemTypes.tournament"),
      license: "general.globalSearch.itemTypes.license",
      club: "general.globalSearch.itemTypes.club",
      league: addLeagueNamingKey("general.globalSearch.itemTypes.league"),
      team: "general.globalSearch.itemTypes.team",
      transaction: "general.globalSearch.itemTypes.transaction",
      organization: "general.globalSearch.itemTypes.organization",
      platform: "general.globalSearch.itemTypes.platform",
      rankingRule: "league.nav.settings.rankingPoints",
      rankingCategory: "league.nav.settings.rankingCategories",
      tournamentCategory: addTournamentNamingKey("league.nav.settings.tournamentCategories"),
      rankingPointBlock: "league.nav.settings.rankingPoints",
      news: "league.pages.details.tabs.news",
      partner: "league.pages.details.tabs.partners",
      album: "league.pages.details.tabs.gallery",
    }),
    [addLeagueNamingKey, addTournamentNamingKey]
  );

  const getSearchItemTypeLabel = useCallback(
    (type: GlobalSearchItemType) => {
      return t(GLOBAL_SEARCH_ITEM_TYPE_LABELS[type]);
    },
    [GLOBAL_SEARCH_ITEM_TYPE_LABELS, t]
  );

  return getSearchItemTypeLabel;
};
